/** The registration step piece, standard look over its behavior half. */
import { RegistrationStepView } from './RegistrationStepView';
import { useRegistrationStep, type RegistrationStepInput } from './useRegistrationStep';

export function RegistrationStep(props: RegistrationStepInput) {
  return <RegistrationStepView {...useRegistrationStep(props)} />;
}
